import { ENTERPRISE_GROUPS_NAME_MAP } from '~/constants/enterprise-groups';

export const getEnterprisePartnerName = (enterprisePartnerId?: string) =>
  enterprisePartnerId && enterprisePartnerId in ENTERPRISE_GROUPS_NAME_MAP
    ? ENTERPRISE_GROUPS_NAME_MAP[enterprisePartnerId]
    : undefined;
